import { apiClient } from '@/config/api';
import {
    MenuWithDetails,
    UpdateMenuTreeDto,
    AvailableCategory,
    AvailablePage,
    MenuApiResponse,
    AvailableItemsResponse
} from '@/types/menu';

class MenuService {
    // Lấy menu tree với thông tin chi tiết
    async getMenuTree(): Promise<MenuWithDetails> {
        const response = await apiClient.get<MenuApiResponse>('/menus');

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy menu tree');
        }

        if (!response.data?.data) {
            throw new Error('Không có dữ liệu menu');
        }

        return response.data.data;
    }

    // Cập nhật menu tree
    async updateMenu(updateMenuDto: UpdateMenuTreeDto): Promise<MenuWithDetails> {
        const response = await apiClient.put<MenuApiResponse>('/menus', updateMenuDto);

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi cập nhật menu');
        }

        if (!response.data?.data) {
            throw new Error('Không có dữ liệu menu sau khi cập nhật');
        }

        return response.data.data;
    }

    // Lấy danh sách category gốc để chọn cho menu
    async getAvailableCategories(search?: string): Promise<AvailableCategory[]> {
        const params = search ? { search } : undefined;
        const response: any = await apiClient.get<AvailableItemsResponse>('/menus/available/categories', params);
        console.log("response: ", response);
        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy danh sách category');
        }

        return response.data?.data?.data?.categories as AvailableCategory[];
    }

    // Lấy danh sách page để chọn cho menu
    async getAvailablePages(search?: string): Promise<AvailablePage[]> {
        const params = search ? { search } : undefined;
        const response: any = await apiClient.get<AvailableItemsResponse>('/menus/available/pages', params);

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy danh sách page');
        }

        return response.data?.data?.data?.pages as AvailablePage[];
    }

    // Lấy danh sách category con
    async getCategoryChildren(categoryId: string, search?: string): Promise<AvailableCategory[]> {
        const params = search ? { search } : undefined;
        const response = await apiClient.get<AvailableItemsResponse>(`/menus/available/categories/${categoryId}/children`, params);

        if (!response.ok) {
            throw new Error(response.data?.message || 'Lỗi khi lấy danh sách category con');
        }

        return response.data?.data.items as AvailableCategory[];
    }
}

export const menuService = new MenuService();
